(() => {
  const MOBILE_MAX_WIDTH = 999;
  const isMobileViewport = () => window.innerWidth <= MOBILE_MAX_WIDTH;

  let lastFocused = null;
  let activePopup = null;

  const resolvePopup = () => document.querySelector('[data-texture-preview]');

  const openPopup = (imageUrl, label) => {
    if (!imageUrl) return;
    const popup = resolvePopup();
    if (!popup) return;

    const popupImage = popup.querySelector('[data-texture-preview-image]');
    const popupLabel = popup.querySelector('[data-texture-preview-label]');
    if (!popupImage) return;

    popupImage.src = imageUrl;
    popupImage.alt = label || '';
    if (popupLabel) popupLabel.textContent = label || '';

    lastFocused = document.activeElement;
    activePopup = popup;
    popup.hidden = false;
    void popup.offsetWidth;
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    const popup = activePopup || resolvePopup();
    if (!popup) return;
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => {
      popup.hidden = true;
      const popupImage = popup.querySelector('[data-texture-preview-image]');
      if (popupImage) popupImage.src = '';
    }, 250);
    activePopup = null;
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) { /* noop */ }
    }
  };

  const resolveTextureData = (target) => {
    if (!target.closest) return null;
    const trigger = target.closest('[data-texture-preview-trigger]');
    if (!trigger) return null;
    return {
      imageUrl: trigger.getAttribute('data-texture-image'),
      label: trigger.getAttribute('data-texture-label'),
    };
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('[data-texture-preview-close]')) {
      closePopup();
      return;
    }

    const data = resolveTextureData(event.target);
    if (!data || !data.imageUrl) return;
    if (!isMobileViewport()) return;

    event.preventDefault();
    event.stopPropagation();
    openPopup(data.imageUrl, data.label);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activePopup && activePopup.classList.contains('is-active')) {
      closePopup();
    }
  });
})();
